import { Theme, makeStyles } from '@material-ui/core';

import { colors } from '../../assets';

type StyleProps = {
  disablePortal?: boolean;
};

export const useStyles = makeStyles<Theme, StyleProps>(() => ({
  popper: {
    zIndex: ({ disablePortal }) => (disablePortal ? 2 : 1300),
    borderRadius: 4,
    margin: '8px 0px',
    backgroundColor: colors.basic.white,
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
  },
}));
